import React, { useState, useEffect, useRef } from 'react';
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, useNavigate } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import ShowError from "../shared/ShowError";
import { Col, Container, Row } from 'react-bootstrap';
import { Checkbox } from 'primereact/checkbox';


export default function Login(props) {
    const navigate = useNavigate();
    const [mobile, setMobile] = useState("");
    const [password, setPassword] = useState("");
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [saveInLocal, setSaveInLocal] = useState(false);
    const targetRef1 = useRef(null);

    useEffect(() => {
        util.scrollToElement(targetRef1, "center");
        var up = util.getUserAndPass();
        setMobile(up[0]);
        setPassword(up[1]);
        setSaveInLocal(up[0] != "");
    }, []);
    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "mobile") setMobile(val);
        else if(name === "password") setPassword(val);
    }
    const checkDataEntry = function(){
        var check = util.IsMobileValid(mobile);
        if(!check.valid){
            setErorVisible(true);
            setErrorMessage(check.msg);
            return false;
        }
        if(password.length == 0){
            setErrorMessage("کلمه عبور را وارد کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
        if(!checkDataEntry()) return;
        if(saveInLocal){
            util.saveUserAndPass(mobile, password);
        }
        else{
            util.deleteUserAndPass();
        }
        setSaving(true);
        var params = {mobile:mobile, password:password};
        var url = config.Server+`/user/login`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    util.deleteSoftwareTargetContractNo();
                    
                    var user = response;
                    var ExpireTime = new Date().getTime() / 1000;
                    ExpireTime += (30 * 60 * 1000);
                    user["ExpireTime"] = ExpireTime;
                    util.setCurrentUser(user);
                    setSaving(false);
                    var afterLogin = util.getAfterLoginUrl();
                    if ((user.role.id === util.UserRoles.Admin)||(user.role.id === util.UserRoles.Assistant)) {
                        afterLogin = "admin";
                    }
                    console.log("after login is>", afterLogin);
                    var redirect = "/home";
                    if(afterLogin == "complete_buy_product"){
                        redirect = "/buy/product/summary";
                    }
                    else if(afterLogin == "admin"){
                        redirect = "/admin/contract/list";
                    }
                    else if(afterLogin == ""){
                        if(util.getBuy() != null){
                            redirect = "/buy-product";
                        }
                    }
                    
                    if(props.onLoggedIn)props.onLoggedIn();                                        
                    navigate(redirect);
                    util.deleteAfterLoginUrl();
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }

    return(
        (redirectUrl != "")?
        <>
            <Navigate to={redirectUrl} replace={false}  />
        </>
        :
        <>
            <Row style={{padding:"0px", margin:"20px 0px 0px 0px"}} ref={targetRef1}>
                <Col className="d-flex justify-content-center align-items-center" style={{}}>
                    <Col md={3} style={{border:"1px solid #b0b0b0", padding:"10px", borderRadius:"10px"}}>
                        <table style={{width:"100%", minWidth:"250px", marginLeft:"auto", marginRight:"auto"}}>
                            <tbody>
                                <tr>
                                    <td style={{width:"100%", textAlign:"center"}}>
                                        <img src={require('../lib/images/hana.webp')} style={{width:"64px"}} />
                                        {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                                    </td>
                                </tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center"}}>ورود به پرتال مشتریان هانا</td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                        <FloatLabel>
                                            <InputText value={mobile} onChange={(e)=>{onInputChange(e, "mobile")}} id="mobile" keyfilter="int" maxLength={11} className="p-inputtext-lg" style={{width:"100%", textAlign:"center", direction:"ltr"}} />
                                            <label htmlFor="mobile">موبایل</label>
                                        </FloatLabel>
                                        
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                        <FloatLabel>
                                            <Password value={password} onChange={(e)=>{onInputChange(e, "password")}} id="password" maxLength={30} className="p-inputtext-lg" pt={{
                                                            iconField: {
                                                                root: {
                                                                style: { width: "100%" },
                                                                },
                                                            },
                                                            input: {
                                                                style: { width: "100%", textAlign:"center" },
                                                            },
                                                            root: {
                                                                style: { width: "100%" },
                                                            },
                                                            }} toggleMask feedback={false} />
                                            <label htmlFor="password">کلمه عبور</label>
                                        </FloatLabel>
                                        
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td>
                                        <div key={"isActive"} className="flex align-items-center">
                                            <Checkbox value={saveInLocal} onChange={(e)=>setSaveInLocal(e.checked)} checked={saveInLocal} />
                                            <label onClick={()=>setSaveInLocal(!saveInLocal)} className="ml-2">&nbsp;نام کاربری و کلمه عبور ذخیره شوند</label>
                                        </div>
                                    </td>
                                </tr>
                                <tr><td>&nbsp;</td></tr>
                                <tr>
                                    <td style={{textAlign:"right"}}>
                                    <React.Fragment>
                                        <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                                            <Button style={{borderRadius:"5px"}} label="ورود به داشبورد" icon="pi pi-check" onClick={()=>saveItem()} loading={saving} severity="success" iconPos="right" />
                                        </div>
                                    </React.Fragment>

                                    </td>
                                </tr>

                            </tbody>
                        </table>
                        <div style={{width:"100%", paddingBottom:"10px"}}>
                            <div style={{textAlign:"right", direction:"rtl", marginTop:"20px"}}>
                                <Link to="/reset-password" style={{textDecoration:"none", color:"#a0a0a0"}}>کلمه عبور را فراموش کرده ام</Link>
                            </div>
                            <div style={{textAlign:"right", direction:"rtl", marginTop:"20px"}}>
                                <Link to="/request-membership" style={{textDecoration:"none", color:"#a0a0a0"}}>ثبت نام</Link>
                            </div>
                            <div style={{textAlign:"center", padding:"5px", direction:"rtl", borderTop:"1px dotted #b0b0b0", marginTop:"20px", borderBottom:"1px dotted #b0b0b0"}}>
                                تماس با ما: <label  style={{direction:"ltr"}}><a href="tel:08733741914">087 3374 1914</a></label>,&nbsp;&nbsp;&nbsp;
                                <label  style={{direction:"ltr"}}><a href="tel:08733741916">087 3374 1916</a></label>
                            </div>
                        </div>
                    </Col>
                </Col>
            </Row>
            <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    )
}